import React from "react";
import { FetchResult } from "@apollo/client";
import {
  GetCurrentPublicUserQuery,
  useGetCurrentPublicUserQuery,
} from "../../../generated/graphql";

export interface PublicUserContextType {
  currentPublicUser: Maybe<GetCurrentPublicUserQuery["currentPublicUser"]>;
  currentPublicUserLoading: boolean;
  refetchCurrentPublicUser: () => Promise<
    FetchResult<GetCurrentPublicUserQuery>
  >;
}

export const PublicUserContext = React.createContext<PublicUserContextType>({
  currentPublicUser: null,
  currentPublicUserLoading: false,
  refetchCurrentPublicUser: () =>
    Promise.resolve({} as FetchResult<GetCurrentPublicUserQuery>),
});

interface Props {
  children: React.ReactNode;
}

const PublicUserContextProvider = ({ children }: Props) => {
  const {
    data: currentPublicUserData,
    loading: currentPublicUserLoading,
    refetch: refetchCurrentPublicUser,
  } = useGetCurrentPublicUserQuery({});

  return (
    <PublicUserContext.Provider
      value={{
        currentPublicUser: currentPublicUserData?.currentPublicUser ?? null,
        currentPublicUserLoading,
        refetchCurrentPublicUser,
      }}
    >
      {children}
    </PublicUserContext.Provider>
  );
};

export default PublicUserContextProvider;
